import type { ComponentType } from 'react';

type LandingLoader = () => Promise<{ default: ComponentType<{ onBack?: () => void }> }>;

/**
 * Activation landings the catalog detail page renders for a product whose console lives in a feature
 * package. A page may not import a package or the composition root, so the root fills this object
 * (`src/app/register-oss.tsx`) and the page reads it, like the shared HTTP clients registry. Loaders,
 * not components: the page builds the `lazy` component, so `lazy` stays out of the entry chunk.
 */
export const catalogLandings: {
  /** Object Storage's landing gate (`createOssModule(...).loadStorageLanding`). */
  loadStorageLanding?: LandingLoader;
  /** Cloud Compute's activation landing (`createComputeModule(...).loadActivateLanding`). */
  loadComputeLanding?: LandingLoader;
  /** Managed Kubernetes' activation landing (`createKubernetesModule(...).loadActivateLanding`). */
  loadKubernetesLanding?: LandingLoader;
} = {};
